import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@lmc-env/environment';
import { Observable } from 'rxjs';
import { CoApplicantRemoveRestore, StaleDataNotification } from '@lmc-app/shared/interface/user.interface';
import {
  AgreementPermissionKey,
  ApplicationPermissionKey,
  ApplicationPermissionsConfig,
} from '@lmc-app/core/constants/application-permissions.constant';

@Injectable({
  providedIn: 'root'
})
export class AdminSettingsService {
  private readonly uri: string = `${environment.DO_URL}/v2`;
  constructor(private readonly http: HttpClient) {}
  
  getExternalClients(): Observable<any> {
    return this.http.get(`${this.uri}/externalApiClient`);
  }

  createExternalApiClient(clientData:any): Observable<any> {
    return this.http.post(`${this.uri}/createExternalApiClient`,clientData);
  }

  updateExternalApiClient(field:string,rowData:any): Observable<any> {
    const data = {field,rowData};
    return this.http.post(`${this.uri}/updateExternalApiClient`,data);
  }

  activeNLSsessions(): Observable<any> {
    return this.http.get(`${this.uri}/activeNLSsessions`);
  }

  disconnectNLSsessions(session_id: number, userno: number): Observable<any> {
    return this.http.put(`${this.uri}/disconnectNLSsessions`,{session_id: session_id, userno: userno});
  }

  validateNlsToken(): Observable<any> {
    return this.http.get(`${this.uri}/validateNlsToken`);
  }

  getValidationManager(settingName: string,): Observable<any> {
    return this.http.get(`${this.uri}/docusign/${settingName}`);
  }

  assignValidationManager(settingName: string, managerName: string): Observable<any> {
    return this.http.put(`${this.uri}/docusign/${settingName}`,{ managerName });
  }

  getApplicationPermissionsConfig(): Observable<{ success: boolean; data: ApplicationPermissionsConfig }> {
    return this.http.get<{ success: boolean; data: ApplicationPermissionsConfig }>(
      `${this.uri}/config/application-permissions`
    );
  }

  /** Without "enable" the stored value is kept. */
  updateApplicationPermission(
    key: ApplicationPermissionKey | AgreementPermissionKey,
    permission: { allowedEmployeeIds: number[]; enable?: boolean }
  ): Observable<{ success: boolean; message: string }> {
    return this.http.put<{ success: boolean; message: string }>(
      `${this.uri}/config/application-permissions/${key}`,
      permission
    );
  }

  updateStaleDataNotification(
    staleDataNotification: StaleDataNotification
  ): Observable<{ success: boolean; message: string }> {
    return this.http.put<{ success: boolean; message: string }>(
      `${this.uri}/config/application-permissions/stale-data-notification`,
      staleDataNotification
    );
  }

  updateCoApplicantRemoveRestore(
    coApplicantRemoveRestore: CoApplicantRemoveRestore
  ): Observable<{ success: boolean; message: string }> {
    return this.http.put<{ success: boolean; message: string }>(
      `${this.uri}/config/application-permissions/coapplicant-remove-restore`,
      coApplicantRemoveRestore
    );
  }
}
